import { takeLatest, put, call, all, select } from 'redux-saga/effects';
import find from 'lodash/find';
import isEmpty from 'lodash/isEmpty';
import { isGuestUser } from 'yoda-core-components/lib/helpers/Utils/Utils';
import { addSavedItems } from 'yoda-interfaces/lib/SavedItems/SavedItemsApi';
import showGlobalLoader from 'yoda-checkout-components/lib/actions/ShowGlobalLoaderAction';
import {
    digitalAnalyticsData,
    updateAnalyticsClickAction,
} from 'yoda-checkout-components/lib/actions/CheckoutAnalyticsAction';
import { ANALYTICS_ACTIONS_SAVE_FOR_LATER } from 'yoda-checkout-components/lib/common/Constants';
import TokenProvider from 'yoda-core-components/lib/helpers/TokenProvider/TokenProvider';
import {
    DP_CHECKOUT_SAVED_ITEMS,
    DP_CHECKOUT_SAVED_ITEMS_PAYLOAD,
    SET_SERVICE_ERROR,
} from 'yoda-site-components/lib/common/Constants';
import FactorySaga from 'yoda-site-components/lib/sagas/FactorySaga';
import { resetSflToCartSuccess } from '../actions/SaveForLaterAction';
import { removeCartItem } from '../actions/CartItemsAction';

import {
    SAVE_FOR_LATER_REQUEST,
    SAVE_FOR_LATER_REQUEST_SUCCESS,
    SAVE_FOR_LATER_REQUEST_ERROR,
} from '../actionTypes/CartActionTypes';

function doSavedItems(data) {
    let savedItemObj = {};
    let savedItems = [];
    if (TokenProvider.get(DP_CHECKOUT_SAVED_ITEMS)) {
        savedItemObj = JSON.parse(TokenProvider.get(DP_CHECKOUT_SAVED_ITEMS));
    }
    if (TokenProvider.get(DP_CHECKOUT_SAVED_ITEMS_PAYLOAD)) {
        savedItems = JSON.parse(TokenProvider.get(DP_CHECKOUT_SAVED_ITEMS_PAYLOAD));
    }
    savedItemObj[data.product.id] = {
        id: data.product.id,
    };

    const found = find(
        savedItems,
        (item) => item.product.id === data.product.id || item.itemId === data.itemId
    );
    if (!found || isEmpty(found)) {
        savedItems.push(data);
    }
    TokenProvider.set(DP_CHECKOUT_SAVED_ITEMS, JSON.stringify(savedItemObj));
    TokenProvider.set(DP_CHECKOUT_SAVED_ITEMS_PAYLOAD, JSON.stringify(savedItems));
}

function* saveForLaterSaga(action) {
    try {
        const context = (state) => state.context;
        const appContext = yield select(context);
        const { enablePreSourcing = true } = appContext?.featureFlags || {};
        const saveItemsAction = {
            payload: {
                params: action.payload.postData,
                cartSavedItems: true,
                errorHandler: {
                    context: 'CART',
                    errorComponent: 'CART_SECTION',
                },
            },
        };
        if (enablePreSourcing) {
            saveItemsAction.payload.xClientSource = 'SAVE_FOR_LATER';
            saveItemsAction.payload.excludes = 'DELIVERY_DATES';
        }
        // DA ==> get itemId for save For Later Item
        const saveForLaterItemData = {
            sflItem: {
                itemId: action.payload.id ? action.payload.id : '',
                productId: action.payload.postData[0].itemId
                    ? action.payload.postData[0].itemId
                    : '',
            },
        };

        // DA ==> adding saveForLaterItemData to redux store. We will need this for Analytics
        yield put(digitalAnalyticsData(saveForLaterItemData));

        let result = {};
        if (!isGuestUser()) {
            result = yield call(FactorySaga, addSavedItems, saveItemsAction);
        } else {
            const savedItemsData = TokenProvider.get(DP_CHECKOUT_SAVED_ITEMS_PAYLOAD)
                ? JSON.parse(TokenProvider.get(DP_CHECKOUT_SAVED_ITEMS_PAYLOAD))
                : '[]';
            if (savedItemsData && savedItemsData.length < 50) {
                doSavedItems(saveItemsAction.payload.params[0]);
                result.isSuccess = true;
            } else {
                result.isSuccess = false;
                const errorHandlerInfo = saveItemsAction.payload.errorHandler;
                errorHandlerInfo.errorCode = 'SRV_ITEMCOUNT_EXCEED';
                errorHandlerInfo.errorMessage = 'Limit of list items reached.';
                yield put({ type: SET_SERVICE_ERROR, errorHandlerInfo });
            }
        }
        if (result.isSuccess) {
            yield all([
                // DA ==> trigger 'saveProductInCart' once item is added to saved items list
                put(updateAnalyticsClickAction(ANALYTICS_ACTIONS_SAVE_FOR_LATER)),
                put(removeCartItem(action.payload.id, true)),
                put(resetSflToCartSuccess()),
                put({ type: SAVE_FOR_LATER_REQUEST_SUCCESS }),
            ]);
        } else {
            yield put(showGlobalLoader(false));
        }
    } catch (error) {
        yield all([
            // Need to show appropriate error in this case
            put({ type: SAVE_FOR_LATER_REQUEST_ERROR, error }),
            put(showGlobalLoader(false)),
        ]);
    }
}

const watchSaveForLater = function* watchSaveForLater() {
    yield takeLatest(SAVE_FOR_LATER_REQUEST, saveForLaterSaga);
};
watchSaveForLater.sagaName = 'watchSaveForLater';

export default watchSaveForLater;
